// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase, ref, get, push } from "firebase/database";

// default
const firebaseConfig = {
    apiKey: "AIzaSyAhCsyZPlDYG87jc0ayyn1b9jacqGgilBg",
    authDomain: "opro-d1fea.firebaseapp.com",
    databaseURL: "https://opro-d1fea.firebaseio.com",
    projectId: "opro-d1fea",
    storageBucket: "opro-d1fea.appspot.com",
    messagingSenderId: "767120609668",
    appId: "1:767120609668:web:1d5199a69062844d30cdd1",
};
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

// orders
const firebaseOrdersConfig = {
    apiKey: "AIzaSyClQ8vmPYX0qfzG_I8oK09sZvD-_GSznRw",
    authDomain: "tsatsky-orders.firebaseapp.com",
    databaseURL:
        "https://tsatsky-orders-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "tsatsky-orders",
    storageBucket: "tsatsky-orders.firebasestorage.app",
    messagingSenderId: "1086067052822",
    appId: "1:1086067052822:web:4494a8b9323a9ca97e8037",
    measurementId: "G-55ZSND7FGN",
};
const appOrders = initializeApp(firebaseOrdersConfig, "orders");
const databaseOrders = getDatabase(appOrders);

// orders
const firebaseStatsConfig = {
    apiKey: "AIzaSyDsDsBsZqLvCCzmk3vrs90SwGKFrf0V6Pg",
    authDomain: "tsatsky-stats.firebaseapp.com",
    databaseURL:
        "https://tsatsky-stats-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "tsatsky-stats",
    storageBucket: "tsatsky-stats.firebasestorage.app",
    messagingSenderId: "162141173297",
    appId: "1:162141173297:web:b0b6a65d18fa19aec24710",
};
const appStats = initializeApp(firebaseStatsConfig, "stats");
const databaseStats = getDatabase(appStats);

export { database, databaseOrders, databaseStats, ref, get, push };
